module.exports = __webpack_public_path__ + "static/media/avatar-icon.c7b5f6a0.png";